import { Button } from '@/components/ui/button';
import { useState } from 'react';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useSession } from '@/contexts/LitSessionProvider';
import { toLocaleFixedNumber, toSpecialFixed } from '@/lib/misc/utils';
import { BalanceItem } from './BalanceItem';
import Link from 'next/link';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { IoTriangle } from 'react-icons/io5';
export default function UserBalances() {
  const [showCashModal, setShowCashModal] = useState(false);
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: isLoadingAssetData
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const totalBalance = () => {
    let totalUsd = 0;
    if (assetData && assetData?.balances.length) {
      assetData.balances.map(token => {
        if (token?.usd_value) totalUsd += token.usd_value;
      });
    }
    return totalUsd;
  };
  const usdChange = assetData?.totalUsdValue - assetData?.totalUsdValue24h;
  const percentChange = usdChange / assetData?.totalUsdValue24h * 100; // ~4.17%

  return <Link href='/portfolio' className='w-full' data-sentry-element="Link" data-sentry-component="UserBalances" data-sentry-source-file="UserBalances.tsx">
      <div className='genius-shadow mb-4 items-center bg-genius-indigo rounded-[20px] border-genius-blue hover:bg-genius-blue border-[1px] overflow-hidden h-fit flex items-center'>
        <div>
          <div className='p-3 pb-0 flex items-center justify-between'>
            <p className='text-[20px]'>Balances</p>
            <div className='flex items-center justify-center'>
              <div></div>
            </div>
            {/* <Link
                    href="/portfolio"
                    className="px-0 w-[83px] h-[32px] ta-c justify-center rounded-full bg-genius-blue hover:bg-genius-blue text-[14px] flex items-center">
                    See All
                </Link> */}
          </div>
          <div className='pb-2'>
            <>
              <div className='px-3'>
                <p className='text-[32px]'>${toSpecialFixed(totalBalance(), 2).value}</p>

                {/* <p
                            className={`${usdChange >= 0 ? 'text-green-400' : 'text-red-400'
                                } text-[12px] font-normal ml-1 flex items-center`}
                        >
                            {usdChange >= 0 ? (
                                <IoTriangle color='#34D399' className="mr-2" size={12} />
                            ) : (
                                <TbTriangleInvertedFilled color='#FF5B5B' className="mr-2" size={12} />
                            )}
                            ${toLocaleFixedNumber(Math.abs(usdChange))}{' '}
                            {assetData?.totalUsdValue24h
                                ? '(' + toLocaleFixedNumber(Math.abs(percentChange)) + '%)'
                                : ''}
                            <span className="ml-2 text-genius-cream/50">Today</span>
                        </p>
                 */}
              </div>
            </>
          </div>
        </div>
      </div>
    </Link>;
}